import { CurrencyIso } from './converters/convertCurrencyIso';
import formatPrice from './formatPrice';

const formatPriceWithCurrency = (
  price: number,
  currencyIso: CurrencyIso,
  locale: string,
  round: boolean = false
): string => {
  let formattedPrice: string = formatPrice(price, locale, round);
  switch (currencyIso) {
    case CurrencyIso.HUF:
      formattedPrice = formattedPrice + ' Ft';
      break;
    case CurrencyIso.CHF:
      formattedPrice = 'CHF ' + formattedPrice;
      break;
    case CurrencyIso.EUR:
      formattedPrice = formattedPrice + ' €';
      break;
    case CurrencyIso.GBP:
      formattedPrice = '£' + formattedPrice;
      break;
    case CurrencyIso.JPY:
      formattedPrice = '¥' + formattedPrice;
      break;
    case CurrencyIso.USD:
      formattedPrice = '$' + formattedPrice;
      break;
    default:
      throw new Error('Unknown currency ISO: ' + currencyIso);
  }

  return formattedPrice;
};

export default formatPriceWithCurrency;
